// src/pages/Dashboard.js
import React, { useState, useEffect } from 'react';
import { FaPen } from 'react-icons/fa'; // Importing a pencil icon

const Dashboard = () => {
  const [fullName, setFullName] = useState('');
  const [profilePhoto, setProfilePhoto] = useState(null);
  const [subscriptionExpiration, setSubscriptionExpiration] = useState(new Date(Date.now() + 30 * 24 * 60 * 60 * 1000)); // 30 days from now
  const [isEditing, setIsEditing] = useState(true); // Track if the profile is in edit mode

  useEffect(() => {
    // Load saved profile data from localStorage when the component mounts
    const savedProfile = JSON.parse(localStorage.getItem('profile'));
    if (savedProfile) {
      setFullName(savedProfile.fullName || '');
      setProfilePhoto(savedProfile.profilePhoto || null);
    }
  }, []);

  const handlePhotoChange = (e) => {
    setProfilePhoto(e.target.files[0]);
  };

  const handleNameChange = (e) => {
    setFullName(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Save profile data to localStorage
    const profileData = {
      fullName: fullName,
      profilePhoto: profilePhoto ? URL.createObjectURL(profilePhoto) : null,
    };
    localStorage.setItem('profile', JSON.stringify(profileData));

    // Switch to non-editable mode
    setIsEditing(false);
  };

  const formatExpirationDate = (date) => {
    return date.toLocaleDateString(); // Format the date as needed
  };

  const handleLogout = () => {
    // Logic to clear user session and redirect to login
    localStorage.removeItem('token'); // Example of clearing token
    window.location.href = '/login'; // Redirect to login page
  };

  return (
    <div className="container mt-5">
      <h2>Welcome to Your Dashboard</h2>
      <p>Track your progress and continue learning.</p>

      {/* User Information */}
      <div className="card my-4 p-4">
        <h4>User Profile</h4>
        
        {isEditing ? (
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="fullName" className="form-label">Full Name</label>
              <input
                type="text"
                id="fullName"
                value={fullName}
                onChange={handleNameChange}
                className="form-control"
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="profilePhoto" className="form-label">Profile Photo</label>
              <input
                type="file"
                id="profilePhoto"
                accept="image/*"
                onChange={handlePhotoChange}
                className="form-control"
              />
            </div>

            <button type="submit" className="btn btn-primary">Save Profile</button>
          </form>
        ) : (
          <div>
            <h5>{fullName || 'No Name Provided'}</h5>
            {profilePhoto && <img src={profilePhoto} alt="Profile" className="img-thumbnail mb-3" style={{ width: '150px' }} />}
            <button onClick={() => setIsEditing(true)} className="btn btn-link"><FaPen /> Edit</button>
          </div>
        )}

        <p>Subscription Status: Active</p>
        <p>Subscription Expiration: {formatExpirationDate(subscriptionExpiration)}</p>
        <a href="/change-password" className="btn btn-link">Change Password</a>
        <button onClick={handleLogout} className="btn btn-danger">Logout</button>
      </div>

      {/* Available Courses */}
      
    </div>
  );
};

export default Dashboard;
